import gql from "graphql-tag";

export const searchQuery = gql`
  query SearchUserTarget(
    $id: ID!
    $searchText: String
    $targetSelection: TargetFilterType
    $listFilter: CreateGridFiltersInput
    $userId: ID
    $userNextToken: String
    $targetNextToken: String
  ) {
    getCompany(id: $id) {
      users(
        filter: { fullName: { contains: $searchText } }
        nextToken: $userNextToken
      ) {
        nextToken
        items {
          id
          firstName
          lastName
          fullName
          status
          profileImage {
            url
            fileName
          }
        }
      }
      listTargetCustom(
        targetListType: TargetList
        targetSelection: $targetSelection
        filter: { title: { contains: $searchText } }
        listFilter: $listFilter
        nextToken: $targetNextToken
      ) {
        items {
          type
          targets {
            id
            title
            logo {
              url
              fileName
            }
          }
          nextToken
        }
      }
      checkinSearch(searchText: $searchText, userId: $userId) {
        items {
          id
          name
          checkInType
          combinedCheckInTypes
          showCheckinDetails
          checkInTargetId
        }
      }
      successStorySearch(searchText: $searchText, userId: $userId) {
        items {
          id
          title
          isPerformanceReview
        }
      }
    }
  }
`;

export const getDashboardConfiguration = gql`
  query getDashboardConfiguration($userCompanyId: ID!, $id: ID!) {
    getUser(userCompanyId: $userCompanyId, id: $id) {
      dashboardConfiguration {
        position
        widget
        hidden
        isEnabled
        name
      }
    }
  }
`;

export const getUserProfileConfiguration = gql`
  query getUserProfileConfiguration($userCompanyId: ID!, $id: ID!) {
    getUser(userCompanyId: $userCompanyId, id: $id) {
      profileWidgetConfiguration {
        position
        widget
        hidden
        isEnabled
        name
      }
    }
  }
`;

export const companyTargets = gql`
  query companyTargets(
    $id: ID!
    $companyId: ID!
    $targetListType: TargetListType
    $targetSelection: TargetFilterType
    $listFilter: CreateGridFiltersInput
    $nextToken: String
  ) {
    getUser(id: $id, userCompanyId: $companyId) {
      listTargetCustom(
        targetListType: $targetListType
        userId: $id
        targetSelection: $targetSelection
        listFilter: $listFilter
        nextToken: $nextToken
      ) {
        items {
          targets {
            id
            isNew
            targetStatus
            title
            type
            description
            dueDate
            coachTarget {
              items {
                coachid
                coach {
                  firstName
                  lastName
                  profileImage {
                    fileName
                  }
                }
              }
            }
            logo {
              url
              fileName
            }
            createdBy {
              firstName
              fullName
              lastName
              profileImage {
                url
                fileName
              }
            }
          }
          nextToken
          type
        }
      }
      isAssignedToTargets
    }
  }
`;

export const teamTargetInfo = gql`
  query teamTargetInfo($id: ID!) {
    getTarget(id: $id) {
      id
      companyId
      isNew
      title
      type
      description
      reviewStatus
      targetTag
      createdByUserId
      startDate
      userTargetStatusOfLoginUser {
        id
        status
        enableMarkCompletionRequest
        selfRating
        leadReviewerRating
      }
      primaryCoach {
        profileImage {
          url
          fileName
        }
        id
        firstName
        lastName
        fullName
        status
      }
      skills {
        definitions {
          definition
          frequency
        }
        name
      }
      skillsAndStrengths {
        id
        name
        isStrength
        color
        category
      }
      linkTarget {
        id
        title
        description
        type
        createdByUserId
        dueDate
        targetUser {
          items {
            id
          }
        }
        targetStatus
        createdBy {
          firstName
          lastName
          profileImage {
            url
            fileName
          }
        }
        unsplashImage {
          url
          fileName
        }
        logo {
          url
          fileName
        }
      }
      strengths {
        color
        createdAt
        description
        id
        name
        updatedAt
      }
      logo {
        url
        fileName
      }
      unsplashImage {
        url
        fileName
      }
      targetAttachmentLinks
      document {
        bucket
        key
        region
        url
        uploadUrl
        fileName
      }
      dueDate
      weightage
      targetUser {
        items {
          id
          targetid
          userid
          user {
            id
            eeid
            firstName
            lastName
            fullName
            designation
            department
            profileImage {
              url
              fileName
            }
            status
          }
        }
      }
      coachTarget {
        items {
          id
          targetid
          coachid
          appointedAsCreator
          coach {
            id
            eeid
            firstName
            lastName
            role
            department
            designation
            profileImage {
              url
              fileName
            }
            status
          }
        }
      }
      targetStatus
      createdBy {
        firstName
        fullName
        id
        lastName
        department
        designation
        profileImage {
          url
          fileName
        }
        role
        status
      }
      createdAt
      updatedAt
      targetObjective {
        items {
          id
        }
      }
      checkin {
        items {
          id
        }
      }
    }
  }
`;

export const getUserObjectivesForDashboardWidget = gql`
  query getUserObjectivesForDashboardWidget($id: ID!) {
    getUserObjectivesForDashboardWidget(id: $id) {
      ObjectiveWidget {
        id
        title
        targetStatus
        description
        type
        logo {
          fileName
        }
        enableMarkCompletionRequest
        createdBy {
          firstName
          lastName
          profileImage {
            fileName
          }
        }
        dueDate
        completionApprovalRequired
        objective {
          id
          dueDate
          name
          status
          subStatus
          targetobjectiveid
          completionRequired
          objectiveSequenceNo
          comment
          commentedDate
          userDetails {
            id
            firstName
            lastName
            department
            profileImage {
              fileName
            }
          }
        }
      }
      isObjectiveCompleted
    }
  }
`;

export const objectiveWidget = gql`
  query objectiveWidget($id: ID!, $companyId: ID!) {
    getUser(userCompanyId: $companyId, id: $id) {
      userObjective(
        filter: {
          or: [{ status: { eq: OVERDUE } }, { status: { eq: INPROGRESS } }]
        }
      ) {
        items {
          id
          userid
          status
          subStatus
          targetobjective {
            id
            name
            objectiveSequenceNo
            target {
              id
              title
              dueDate
              targetStatus
              createdBy {
                firstName
                fullName
                lastName
                department
                profileImage {
                  url
                  fileName
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const objectiveWidgetCompleted = gql`
  query objectiveWidgetCompleted($id: ID!, $companyId: ID!) {
    getUser(userCompanyId: $companyId, id: $id) {
      userObjective(filter: { status: { eq: COMPLETE } }) {
        items {
          id
        }
      }
    }
  }
`;

export const dashboardReports = gql`
  query dashboardReports(
    $id: ID!
    $companyId: ID!
    $year: String
    $actionType: DashbordActionType
  ) {
    getUser(userCompanyId: $companyId, id: $id) {
      userDashboardReport(year: $year, actionType: $actionType) {
        targetOverview {
          color
          percentage
          targetType
          count
        }
        topStrengthsStatistics {
          color
          count
          strength
          month
        }
        dashboardTargetStatistics {
          targetStatistics {
            completedTargets
            pausedTargets
            totalTargets
            todaysDueTargets
          }
          statisticsType
        }
      }
    }
  }
`;

export const targetOverview = gql`
  query targetOverview(
    $id: ID!
    $companyId: ID!
    $year: String
    $actionType: DashbordActionType
  ) {
    getUser(userCompanyId: $companyId, id: $id) {
      userDashboardReport(year: $year, actionType: $actionType) {
        targetOverview {
          color
          percentage
          targetType
          count
        }
      }
    }
  }
`;

export const topStrengthsStatistics = gql`
  query topStrengthsStatistics(
    $id: ID!
    $companyId: ID!
    $year: String
    $actionType: DashbordActionType
  ) {
    getUser(userCompanyId: $companyId, id: $id) {
      userDashboardReport(year: $year, actionType: $actionType) {
        strengthsGraphData {
          data {
            name
            month
            value
            taggedOn
            rankedStrength
            color
          }
        }
      }
    }
  }
`;

export const dashboardTargetStatistics = gql`
  query dashboardTargetStatistics(
    $id: ID!
    $companyId: ID!
    $year: String
    $actionType: DashbordActionType
  ) {
    getUser(userCompanyId: $companyId, id: $id) {
      userDashboardReport(year: $year, actionType: $actionType) {
        dashboardTargetStatistics {
          targetStatistics {
            completedTargets
            pausedTargets
            totalTargets
            todaysDueTargets
          }
          statisticsType
        }
      }
    }
  }
`;
export const checkinWidget = gql`
  query getCheckinsForDashboardWidget($isLearning: Boolean) {
    getCheckinsForDashboardWidget(isLearning: $isLearning) {
      CheckInWidget {
        checkInType
        checkinId
        endDate
        createdBy {
          id
          firstName
          lastName
          profileImage {
            url
            fileName
          }
        }
        description
        checkInStatus
        id
        name
        isNew
        isNewHighlight
        checkInTargetId
        linkCheckin {
          link
          title
          description
          image
        }
        multimediaCheckin {
          s3Link {
            fileName
            url
          }
        }
      }
      isCheckinCompleted
    }
  }
`;
// export const checkinDashboardWidget = gql`
//   query checkinDashboardWidget(
//     $id: ID!
//     $companyId: ID!
//     $checkinListType: CheckinListType
//     $checkinSelection: TargetFilterType
//   ) {
//     getUser(id: $id, userCompanyId: $companyId) {
//       listCheckinCustom(
//         checkinListType: $checkinListType
//         checkinSelection: $checkinSelection
//       ) {
//         items {
//           type
//           checkinsCompleted
//           checkins {
//             isNew
//             combinedCheckInTypes
//             name
//             checkInType
//             publishPeriod
//             userRoleTypeForSRS
//             description
//             scheduleFrequency
//             frequencyRepeatsOn
//             startDate
//             endDate
//             checkInStatus
//             checkInTargetId
//             target {
//               id
//               title
//               dueDate
//             }
//             usercheckinForDashboard {
//               isNew
//               id
//               checkinid
//               userid
//               checkInStatus
//               checkInStartDate
//               checkInEndDate
//               checkinSequenceNo
//               ratees {
//                 status
//                 ratee {
//                   userid
//                   firstName
//                   lastName
//                   profileImage {
//                     url
//                     fileName
//                   }
//                 }
//               }
//             }
//             checkInType
//             createdByUserId
//             createdBy {
//               profileImage {
//                 url
//                 fileName
//               }
//               firstName
//               lastName
//               fullName
//               department
//             }
//           }
//         }
//       }
//     }
//   }
// `;

// export const checkinDashboardMultimediaWidget = gql`
//   query checkinDashboardWidget(
//     $id: ID!
//     $companyId: ID!
//     $checkinListType: CheckinListType
//     $checkinSelection: TargetFilterType
//   ) {
//     getUser(id: $id, userCompanyId: $companyId) {
//       listCheckinCustom(
//         checkinListType: $checkinListType
//         checkinSelection: $checkinSelection
//       ) {
//         items {
//           type
//           checkinsCompleted
//           checkins {
//             isNew
//             combinedCheckInTypes
//             name
//             checkInType
//             publishPeriod
//             description
//             scheduleFrequency
//             frequencyRepeatsOn
//             startDate
//             endDate
//             checkInStatus
//             checkInTargetId
//             usercheckinForDashboard {
//               isNew
//               id
//               checkinid
//               userid
//             }
//             linkCheckin {
//               link
//             }
//             multimediaCheckin {
//               fileType
//               s3Link {
//                 fileName
//                 key
//                 url
//               }
//               isVideoUrl
//             }
//             checkInType
//             createdByUserId
//             createdBy {
//               profileImage {
//                 url
//                 fileName
//               }
//               firstName
//               lastName
//               fullName
//               department
//             }
//           }
//         }
//       }
//     }
//   }
// `;
